import React from 'react';
import { useParams } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';
import ColoredTab from '../components/elements/ColoredTab';
import AccountDetailsPage from './Account/AccountDetailsPage';
import AccountTransactionsPage from './Account/AccountTransactionsPage';
import AccountUploadViewDocumentsPage from './Account/AccountUploadViewDocumentsPage';

const AccountViewPage = ({ acctNumber }: AccountViewPageParams) => {

	const tabs = [
		{ menuItem: 'Details', render: function detailsPane() { return (
			<Tab.Pane>
				<AccountDetailsPage acctNumber={acctNumber} />
			</Tab.Pane>
		); } },
		{ menuItem: 'Transactions', render: function transactionsPane() { return (
			<Tab.Pane>
				<AccountTransactionsPage acctNumber={acctNumber} />
			</Tab.Pane>)
		; } },
		{ menuItem: 'Upload / View Documents', render: function uploadViewDocumentsPane() { return (
			<Tab.Pane>
				<AccountUploadViewDocumentsPage acctNumber={acctNumber} />
			</Tab.Pane>
		); } }
	];

	return <ColoredTab panes={tabs} />;
};

export interface AccountViewPageParams {
	acctNumber: string
}

export default AccountViewPage;